import React from 'react';

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

export const PreviewOrLaunchModal = ({ classroomUnitId, lessonUID, lessonID, completed, closeModal }) => {
  const { modalRef, } = useModalAccessibility(closeModal)

  function launchLessonLink() {
    if (classroomUnitId && (lessonUID || lessonID)) {
      return `/teachers/classroom_units/${classroomUnitId}/launch_lesson/${lessonUID || lessonID}`;
    } else if (lessonID) {
      return `/teachers/units/select_lesson/${lessonID}`;
    }
  }

  return(
    <div className="modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="previewOrLaunchModalTitle"
        aria-modal={true}
        className="preview-or-launch-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <h1 className="title" id="previewOrLaunchModalTitle">Would you like to preview this lesson?</h1>
        <p>You can either preview this lesson or launch it. If you are ready to use this lesson with your students now, launch it.</p>
        <div className="form-buttons">
          <a className="quill-button contained medium green focus-on-light" href={`/preview_lesson/${lessonUID || lessonID}`}>Preview Lesson</a>
          {!completed && <a className="quill-button contained medium green focus-on-light" href={launchLessonLink()}>Launch Lesson</a>}
          <button className="quill-button outlined medium grey focus-on-light" onClick={closeModal} type="button">Cancel</button>
        </div>
      </div>
    </div>
  )
}

export default PreviewOrLaunchModal
